import { MODULE_KIND } from 'types/modules';

import YandexMoneyModuleParams from '../YandexMoneyModuleParams';
import { WidgetModuleParams } from '../Widget/WidgetModuleParams';

export default {
  [MODULE_KIND.YANDEX_MONEY]: YandexMoneyModuleParams,
  [MODULE_KIND.WIDGET]: WidgetModuleParams
};
